var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',[_c('Select2',{attrs:{"options":_vm.options},on:{"change":function($event){return _vm.changekegiatan($event)},"select":function($event){return _vm.mySelectEvent($event)}},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }